import React, { useEffect, useState } from 'react';
import Header from '../components/resuableComponents/Header';
import Footer from '../components/resuableComponents/Footer';
import { AutoComplete, Divider } from 'antd';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Container, Grid, FormControlLabel } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import { DatePicker, Space } from 'antd';
import { Modal } from 'antd';
import moment from 'moment';
import type { DatePickerProps } from 'antd';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Skeleton from '@mui/material/Skeleton';
import { Button } from 'antd';
import {
	fetchCityDispatch,
	AddSearchFlightDispatch,
} from '../reducers/HomeReducer';
import { useLocation, useNavigate } from 'react-router-dom';
import FlightResultSkeleton from '../components/resuableComponents/FlightResultSkeleton';
import TopDrawer from '../components/resuableComponents/TopDrawer';
import Navbar from '../components/resuableComponents/Navbar/Navbar';
import { setSelectedArrival, setSelectedDepart } from '../reducers/UiReducer';
const Option = AutoComplete.Option;
const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
const fareType = ['Refundable', 'Non-Refundable'];
const stopType = ['Non-Stop', '1-Stop', '2+Stop'];
const SearchResultPage = () => {
	const { city } = useSelector((state) => state.home);
	const { tboflight, loading } = useSelector((state) => state.tbo);
	const { etravresult } = useSelector((state) => state.etrav);
	const { tjkresult } = useSelector((state) => state.tripjack);
	const { depart, arrival, tab } = useSelector((state) => state.ui);
	const dispatch = useDispatch();
	const [result, setResult] = useState([]);
	const [adult, setAdult] = useState(1);
	const [child, setChild] = useState(0);
	const [infant, setInfant] = useState(0);
	const [departDate, setDepartDate] = useState('');
	const [airlineS, setairlineS] = useState('');
	const [fare, setFare] = useState('');
	const [stop, setStop] = useState('');
	const [draw, setDraw] = useState(false);
	const [loadings, setLoading] = useState(false);
	const [mod, setMod] = useState(false);
	const [open, setOpen] = useState(false);
	const [scrollVal, SetScrollVal] = useState(10);
	const [hasMorefilterData, SethasMoreFilterData] = useState(true);
	const navigate = useNavigate();
	const location = useLocation();
	console.log('location', location);
	const onChange: DatePickerProps['onChange'] = (date, dateString) => {
		console.log(date, dateString);
		setDepartDate(dateString);
	};
	const showModal = () => {
		setOpen(true);
	};

	const handleOk = () => {
		setLoading(true);
		setTimeout(() => {
			setLoading(false);
			setOpen(false);
		}, 3000);
	};

	const handleCancel = () => {
		setOpen(false);
	};
	const fetchMoreData = () => {
		// if (eltbo === fals && letrav === false && trp === false) {
		// 	if (scrollVal >= filterData.length) {
		// 		SethasMoreFilterData(false);
		// 	}
		// }

		setTimeout(() => {
			SetScrollVal(scrollVal + 5);
		}, 500);
	};

	const handleChange = (value) => {
		let values = value.toLowerCase();
		let cityData = {
			keywords: values,
			limits: 10,
		};
		dispatch(fetchCityDispatch(cityData));
		dispatch(setSelectedDepart(values));
	};
	const opsList =
		city?.result?.length > 0 &&
		city.result?.map((l) => {
			return (
				<Option
					value={`${l.airport_code} - ${l.city_name}`}>{`${l.airport_code} - ${l.city_name} , ${l.country_name}`}</Option>
			);
		});
	const handleChange2 = (value) => {
		let values = value.toLowerCase();
		let cityData = {
			keywords: values,
			limits: 10,
		};
		dispatch(fetchCityDispatch(cityData));
		dispatch(setSelectedArrival(values));
	};
	const opsList2 =
		city?.result?.length > 0 &&
		city.result?.map((l) => {
			return (
				<Option
					value={`${l.airport_code} - ${l.city_name},${l.country_code}`}
					onChange={() =>
						console.log('a', l)
					}>{`${l.airport_code} - ${l.city_name} , ${l.country_name}`}</Option>
			);
		});
	useEffect(() => {
		window.scrollTo(0, 0);
		dispatch(AddSearchFlightDispatch(location.state));
	}, []);
	let combineflightData = [];
	let filterData = [];
	let filterAirlineTBO = [];

	if (loading) {
		console.log('Loading');
	} else {
		let tbo =
			tboflight &&
			tboflight?.result &&
			tboflight?.result?.Response &&
			tboflight?.result?.Response?.Results[0].length > 0 &&
			tboflight?.result?.Response?.Results[0];
		let etrav =
			etravresult &&
			etravresult?.result &&
			etravresult?.result?.TripDetails[0]?.Flights;
		let tjk =
			tjkresult &&
			tjkresult?.result?.searchResult &&
			tjkresult?.result?.searchResult?.tripInfos?.ONWARD?.length > 0 &&
			tjkresult?.result?.searchResult?.tripInfos?.ONWARD;
		console.log('etravh', etrav);
		if (tbo?.length > 0 && etrav?.length > 0 && tjk?.length > 0) {
			combineflightData = [...tbo, ...etrav, ...tjk];
		} else if (tbo?.length > 0 && etrav?.length > 0) {
			combineflightData = [...tbo, ...etrav];
		} else if (tbo?.length > 0 && tjk?.length > 0) {
			combineflightData = [...tbo, ...tjk];
		} else if (etrav?.length > 0 && tjk?.length > 0) {
			combineflightData = [...etrav, ...tjk];
		} else if (etrav?.length > 0 && tbo?.length > 0) {
			combineflightData = [...etrav, ...tbo];
		} else if (tbo?.length > 0) {
			combineflightData = [...tbo];
		} else if (etrav?.length > 0) {
			combineflightData = [...etrav];
		} else if (tjk?.length > 0) {
			combineflightData = [...tjk];
		}
		filterData =
			combineflightData &&
			combineflightData.length > 0 &&
			combineflightData.slice().sort((a, b) => {
				let first =
					a.Supplier === 'TBO'
						? Number(
								Number(Math.round(a.Fare.Total_Amount)) -
									Number(Math.round(a.Fare.MFB_Discount))
						  )
						: a.Supplier === 'ETR'
						? Number(Math.round(a.Fares.Total_Amount))
						: a.Supplier === 'TJK'
						? Number(Math.round(a.totalPriceList.fd.Total_Amount))
						: '';
				let second =
					b.Supplier === 'TBO'
						? Number(
								Number(Math.round(b.Fare.Total_Amount)) -
									Number(Math.round(b.Fare.MFB_Discount))
						  )
						: b.Supplier === 'ETR'
						? Number(Math.round(b.Fares.Total_Amount))
						: b.Supplier === 'TJK'
						? Number(Math.round(b.totalPriceList.fd.Total_Amount))
						: '';
				return first - second;
			});
		if (
			tboflight &&
			tboflight?.result &&
			tboflight?.result?.Response &&
			tboflight?.result?.Response?.Results[0].length > 0
		) {
			filterAirlineTBO = [
				...new Set(
					tboflight &&
						tboflight?.result &&
						tboflight?.result?.Response &&
						tboflight?.result?.Response?.Results[0].length > 0 &&
						tboflight?.result?.Response?.Results[0].map(
							(item) => item.Segments[0]?.[0]?.Airline.AirlineName
						)
				),
			];
		}
	}
	const handleAirline = (event) => {
		// SethasMoreResult(true);
		// SetScrollValResult(10);
		SetScrollVal(10);
		console.log('airline', event.target.name);
		setairlineS(event.target.name);
		if (airlineS === event.target.name) {
			setResult([]);
			setairlineS('');
		} else {
			let filterDataStop = [];
			let filterCombineStop = [];
			let tbo = [];
			if (tboflight) {
				tboflight &&
					tboflight &&
					tboflight.result &&
					tboflight.result.Response &&
					tboflight.result.Response.Results[0].length > 0 &&
					tboflight.result.Response.Results[0].map((item) => {
						if (
							item.Segments[0]?.[0]?.Airline.AirlineName === event.target.name
						) {
							tbo.push({
								...item,
							});
						}
					});
			}
			filterCombineStop = [...tbo];
			filterDataStop =
				filterCombineStop &&
				filterCombineStop.length > 0 &&
				filterCombineStop.slice().sort((a, b) => {
					let first = a.Fare
						? Number(
								Number(Math.round(a.Fare.Total_Amount)) -
									Number(Math.round(a.Fare.MFB_Discount))
						  )
						: a.Fares
						? Number(Math.round(a.Fares.Total_Amount))
						: a.totalPriceList
						? Number(Math.round(a.totalPriceList.fd.Total_Amount))
						: Number(
								Number(Math.round(a.Fare.Total_Amount)) -
									Number(Math.round(a.Fare.MFB_Discount))
						  );
					let second = b.Fare
						? Number(
								Number(Math.round(b.Fare.Total_Amount)) -
									Number(Math.round(b.Fare.MFB_Discount))
						  )
						: b.Fares
						? Number(Math.round(b.Fares.Total_Amount))
						: b.totalPriceList
						? Number(Math.round(b.totalPriceList.fd.Total_Amount))
						: Number(Math.round(b.Fare.Total_Amount)) -
						  Number(Math.round(b.Fare.MFB_Discount));
					return first - second;
				});
			setResult(filterDataStop);
			console.log('filterDataStop', filterDataStop);
			console.log('filterCombineStop', filterCombineStop);
		}
	};
	const handleFareType = (event) => {
		// SethasMoreResult(true);
		// SetScrollValResult(10);
		SetScrollVal(10);
		console.log('airline', event.target.name);
		setFare(event.target.name);
		if (fare === event.target.name) {
			setResult([]);
			setFare('');
		} else {
			let filterDataStop = [];
			let filterCombineStop = [];
			let tbo = [];
			if (tboflight) {
				tboflight &&
					tboflight.result &&
					tboflight.result.Response &&
					tboflight.result.Response.Results[0].length > 0 &&
					tboflight.result.Response.Results[0].map((item) => {
						if (
							event.target.name === 'Refundable'
								? item.IsRefundable
								: !item.IsRefundable
						) {
							tbo.push({
								...item,
							});
						}
					});
			}
			filterCombineStop = [...tbo];
			filterDataStop =
				filterCombineStop &&
				filterCombineStop.length > 0 &&
				filterCombineStop.slice().sort((a, b) => {
					let first = a.Fare
						? Number(
								Number(Math.round(a.Fare.Total_Amount)) -
									Number(Math.round(a.Fare.MFB_Discount))
						  )
						: a.Fares
						? Number(Math.round(a.Fares.Total_Amount))
						: a.totalPriceList
						? Number(Math.round(a.totalPriceList.fd.Total_Amount))
						: Number(
								Number(Math.round(a.Fare.Total_Amount)) -
									Number(Math.round(a.Fare.MFB_Discount))
						  );
					let second = b.Fare
						? Number(
								Number(Math.round(b.Fare.Total_Amount)) -
									Number(Math.round(b.Fare.MFB_Discount))
						  )
						: b.Fares
						? Number(Math.round(b.Fares.Total_Amount))
						: b.totalPriceList
						? Number(Math.round(b.totalPriceList.fd.Total_Amount))
						: Number(Math.round(b.Fare.Total_Amount)) -
						  Number(Math.round(b.Fare.MFB_Discount));
					return first - second;
				});
			setResult(filterDataStop);
			console.log('filterDataStop', filterDataStop);
			console.log('filterCombineStop', filterCombineStop);
		}
	};
	const handleStopType = (event) => {
		// SethasMoreResult(true);
		// SetScrollValResult(10);
		SetScrollVal(10);
		console.log('airline', event.target.name);
		setStop(event.target.name);
		if (stop === event.target.name) {
			setResult([]);
			setStop('');
		} else {
			let filterDataStop = [];
			let filterCombineStop = [];
			let tbo = [];
			if (tboflight) {
				tboflight &&
					tboflight.result &&
					tboflight.result.Response &&
					tboflight.result.Response.Results[0].length > 0 &&
					tboflight.result.Response.Results[0].map((item) => {
						if (
							event.target.name === 'Non-Stop'
								? item.Segments[0].length === 1
								: event.target.name === '1-Stop'
								? item.Segments[0].length === 1
								: item.Segments[0].length > 1
						) {
							tbo.push({
								...item,
							});
						}
					});
			}
			filterCombineStop = [...tbo];
			filterDataStop =
				filterCombineStop &&
				filterCombineStop.length > 0 &&
				filterCombineStop.slice().sort((a, b) => {
					let first = a.Fare
						? Number(
								Number(Math.round(a.Fare.Total_Amount)) -
									Number(Math.round(a.Fare.MFB_Discount))
						  )
						: a.Fares
						? Number(Math.round(a.Fares.Total_Amount))
						: a.totalPriceList
						? Number(Math.round(a.totalPriceList.fd.Total_Amount))
						: Number(
								Number(Math.round(a.Fare.Total_Amount)) -
									Number(Math.round(a.Fare.MFB_Discount))
						  );
					let second = b.Fare
						? Number(
								Number(Math.round(b.Fare.Total_Amount)) -
									Number(Math.round(b.Fare.MFB_Discount))
						  )
						: b.Fares
						? Number(Math.round(b.Fares.Total_Amount))
						: b.totalPriceList
						? Number(Math.round(b.totalPriceList.fd.Total_Amount))
						: Number(Math.round(b.Fare.Total_Amount)) -
						  Number(Math.round(b.Fare.MFB_Discount));
					return first - second;
				});
			setResult(filterDataStop);
			console.log('filterDataStop', filterDataStop);
			console.log('filterCombineStop', filterCombineStop);
		}
	};
	function disabledDate(current) {
		// Can not select days before today and today
		return current && current < moment().endOf('day');
	}
	console.log('result', result);
	console.log('filterAirlineTBO', filterAirlineTBO);
	const handleSearch = () => {
		let formData = {
			AdultCount: adult,
			ChildCount: child,
			InfantCount: infant,
			DirectFlight: false,
			OneStopFlight: false,
			JourneyType: 1,
			PreferredAirlines: null,
			Segments: [
				{
					Origin: depart.split(' ')[0],
					Destination: arrival.split(' ')[0],
					FlightCabinClass: 1,
					PreferredDepartureTime: departDate,
				},
			],
			Sources: 'WEB',
			agent_id: 0,
		};
		navigate('/searchresult', { state: formData });
		dispatch(AddSearchFlightDispatch(formData, navigate));
	};
	return (
		<div>
			<Navbar />
			{filterData?.length > 0 && mod ? (
				<Box style={{ background: '#721053' }}>
					<Box
						style={{
							paddingLeft: 100,
							paddingRight: 100,
							paddingTop: 15,
							paddingBottom: 15,
						}}>
						<Grid container spacing={2}>
							<Grid item xs={12} lg={3}>
								<AutoComplete
									style={{ width: '100%', borderRadius: 2 }}
									dropdownMenuStyle={{
										maxHeight: 1000,
										overflowY: 'visible',
										maxWidth: 500,
									}}
									placeholder='From'
									onChange={handleChange}>
									{opsList}
								</AutoComplete>
							</Grid>
							<Grid item xs={12} lg={3}>
								<AutoComplete
									style={{ width: '100%', borderRadius: 2 }}
									dropdownMenuStyle={{
										maxHeight: 1000,
										overflowY: 'visible',
										maxWidth: 500,
									}}
									placeholder='From'
									onChange={handleChange2}>
									{opsList2}
								</AutoComplete>
							</Grid>
							<Grid item xs={12} lg={2}>
								<DatePicker
									disabledDate={disabledDate}
									onChange={onChange}
									// valuealues={moment('2023-10-30T12:40:14+0000')}
									style={{ width: '100%', padding: 8 }}
								/>
							</Grid>{' '}
							<Grid item xs={12} lg={2}>
								<Button
									onClick={showModal}
									style={{
										textTransform: 'capitalize',
										padding: 7,
										border: '1px solid lightgrey',
										width: '100%',
										height: 'auto',
										color: 'white',
									}}>
									Traveller Class
								</Button>{' '}
								<Modal
									open={open}
									title='Travellers'
									onOk={handleOk}
									onCancel={handleCancel}
									footer={[
										<Button key='back' onClick={handleCancel}>
											OK
										</Button>,
									]}>
									<Box
										style={{
											display: 'flex',
											justifyContent: 'space-between',
										}}>
										<p>Adults(12+yrs)</p>
										<Box>
											<Button
												onClick={() => (adult === 0 ? '' : setAdult(adult - 1))}
												style={{
													fontSize: 14,
													background: 'orange',
													color: 'white',
													fontWeight: 'bold',
												}}>
												--
											</Button>
											<Button
												style={{
													fontSize: 14,
													background: 'white',
													fontWeight: 'bold',
												}}>
												{adult}
											</Button>
											<Button
												onClick={() =>
													adult + child + infant === 9
														? adult
														: setAdult(adult + 1)
												}
												style={{
													fontSize: 14,
													background: 'orange',
													color: 'white',
													fontWeight: 'bold',
												}}>
												+
											</Button>
										</Box>
									</Box>
									<Box
										style={{
											display: 'flex',
											justifyContent: 'space-between',
											marginTop: 5,
										}}>
										<p>Child(2-11yrs)</p>
										<Box>
											<Button
												onClick={() => (child === 0 ? '' : setChild(child - 1))}
												style={{
													fontSize: 14,
													background: 'orange',
													color: 'white',
													fontWeight: 'bold',
												}}>
												--
											</Button>
											<Button
												style={{
													fontSize: 14,
													background: 'white',
													fontWeight: 'bold',
												}}>
												{child}
											</Button>
											<Button
												onClick={() =>
													adult + child + infant === 9
														? child
														: setChild(child + 1)
												}
												style={{
													fontSize: 14,
													background: 'orange',
													color: 'white',
													fontWeight: 'bold',
												}}>
												+
											</Button>
										</Box>
									</Box>
									<Box
										style={{
											display: 'flex',
											justifyContent: 'space-between',
											marginTop: 5,
										}}>
										<p>Infant(0-2yrs)</p>
										<Box>
											<Button
												onClick={() =>
													infant === 0 ? '' : setInfant(infant - 1)
												}
												style={{
													fontSize: 14,
													background: 'orange',
													color: 'white',
													fontWeight: 'bold',
												}}>
												--
											</Button>
											<Button
												style={{
													fontSize: 14,
													background: 'white',
													fontWeight: 'bold',
												}}>
												{infant}
											</Button>
											<Button
												onClick={() =>
													adult + child + infant === 9
														? infant
														: setInfant(infant + 1)
												}
												style={{
													fontSize: 14,
													background: 'orange',
													color: 'white',
													fontWeight: 'bold',
												}}>
												+
											</Button>
										</Box>
									</Box>
								</Modal>
							</Grid>
							<Grid item xs={12} lg={2}>
								<Button
									onClick={handleSearch}
									style={{
										background: '#EC5B24',
										color: 'white',
										width: '100%',
										padding: 7,
										height: 'auto',
									}}>
									Search
								</Button>
							</Grid>
						</Grid>
					</Box>
				</Box>
			) : (
				''
			)}
			{filterData?.length > 0 ? (
				''
			) : (
				<div className='horizontal-bar-wrap' style={{}}>
					<div className='bar1 bar'></div>
				</div>
			)}
			{filterData?.length > 0 ? (
				<Box
					style={{
						background: '#FFF',
						boxShadow: '0 0 10px rgba(0,0,0,.3)',
						paddingLeft: 100,
						paddingRight: 100,
						paddingTop: 10,
					}}>
					<Grid container spacing={2}>
						<Grid item xs={12} lg={3}>
							<Box>
								<span>Stops</span>
							</Box>
							<Box style={{ display: 'flex', flexWrap: 'wrap' }}>
								{stopType &&
									stopType.length > 0 &&
									stopType.map((i, index) => {
										return (
											<FormControlLabel
												control={
													<Checkbox
														checked={stop === i ? true : false}
														onChange={handleStopType}
														name={`${i}`}
														sx={{}}
													/>
												}
												label={
													<>
														<span style={{ fontSize: 12 }}>{i}</span>
													</>
												}
											/>
										);
									})}
							</Box>
						</Grid>
						<Grid item xs={12} lg={4}>
							<Box>
								<span>Airline</span>
							</Box>

							<Box style={{ display: 'flex', flexWrap: 'wrap' }}>
								{filterAirlineTBO &&
									filterAirlineTBO.length > 0 &&
									filterAirlineTBO.map((i, index) => {
										return index < 4 ? (
											<FormControlLabel
												control={
													<Checkbox
														checked={airlineS === i ? true : false}
														onChange={handleAirline}
														name={`${i}`}
														sx={{}}
													/>
												}
												label={
													<>
														<span style={{ fontSize: 12 }}>{i}</span>
													</>
												}
											/>
										) : (
											''
										);
									})}
							</Box>
						</Grid>
						<Grid item xs={12} lg={3}>
							<Box>
								<span>Fare Type</span>
							</Box>
							<Box style={{ display: 'flex', flexWrap: 'wrap' }}>
								{fareType &&
									fareType.length > 0 &&
									fareType.map((i, index) => {
										return (
											<FormControlLabel
												control={
													<Checkbox
														checked={fare === i ? true : false}
														onChange={handleFareType}
														name={`${i}`}
														sx={{}}
													/>
												}
												label={
													<>
														<span style={{ fontSize: 12 }}>{i}</span>
													</>
												}
											/>
										);
									})}
							</Box>
						</Grid>
						<Grid item xs={12} lg={2}>
							<Box style={{ display: 'flex', justifyContent: 'space-between' }}>
								<Box
									style={{
										display: 'flex',
										alignItems: 'center',
										cursor: 'pointer',
									}}
									onClick={() => setDraw(true)}>
									More{' '}
									<i class='fa fa-angle-down' style={{ marginLeft: 5 }}></i>
								</Box>
								<Box
									onClick={() => (mod ? setMod(false) : setMod(true))}
									style={{
										display: 'flex',
										alignItems: 'center',
										cursor: 'pointer',
									}}>
									Modify Search{' '}
									<i class='fa fa-angle-down' style={{ marginLeft: 5 }}></i>
								</Box>
							</Box>
						</Grid>
					</Grid>
				</Box>
			) : (
				''
			)}
			<Box
				style={{
					marginTop: 50,
					marginBottom: 50,
					paddingLeft: 100,
					paddingRight: 100,
				}}>
				<Grid container spacing={4}>
					<Grid item xs={12} lg={8}>
						<Box
							style={{
								display: 'flex',
								justifyContent: 'space-between',
								alignItems: 'center',
								marginBottom: 10,
							}}>
							<h2 style={{ fontSize: 26 }}>
								{`Flight From ${location.state.Segments[0].Origin} to ${
									location.state.Segments[0].Destination
								}(${
									filterData?.length ? filterData?.length : ''
								})`.toLocaleUpperCase()}
							</h2>
							<h3 style={{ fontSize: 20 }}>
								{location.state.Segments[0].PreferredDepartureTime}
							</h3>
						</Box>
						{result ? (
							result?.length > 0 ? (
								<InfiniteScroll
									dataLength={scrollVal}
									next={fetchMoreData}
									hasMore={hasMorefilterData}
									loader={<h4 style={{ textAlign: 'center' }}>Loading...</h4>}
									endMessage={
										<p style={{ textAlign: 'center' }}>
											<b>No More Flights</b>
										</p>
									}>
									{result?.map((item, index) => {
										return index < scrollVal ? (
											<>
												<Box
													style={{
														display: 'flex',
														justifyContent: 'space-between',
														alignItems: 'center',
														borderRadius: 4,
														background: '#fff',
														filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, .25))',
														padding: 30,
														marginTop: 10,
													}}>
													<Box>
														<img
															src={`https://nitish.musafirbazar.com/static/media/${
																item.Supplier === 'TBO'
																	? item.AirlineCode
																	: item.Supplier === 'ETR'
																	? item.Airline_Code
																	: item.Supplier === 'TJK'
																	? item.sI[0].fD.aI.code
																	: ''
															}.gif`}
															style={{ height: 50 }}
														/>
														<br></br>
														<span
															style={{
																color: 'rgba(0,0,0,.38)',
																fontSize: 12,
															}}>
															{item.Supplier === 'TBO'
																? item.Segments[0].slice(0, 1).map((i) => {
																		return i.Airline.AirlineName;
																  })
																: item.Supplier === 'ETR'
																? item.Segments[0].Airline_Name
																: item.Supplier === 'TJK'
																? item.sI[0].fD.aI.name
																: ''}
														</span>
														<br></br>
														<span
															style={{
																color: 'rgba(0,0,0,.38)',
																fontSize: 12,
															}}>
															{`${
																item.Supplier === 'TBO'
																	? item.AirlineCode
																	: item.Supplier === 'ETR'
																	? item.Segments[0].Airline_Code
																	: item.Supplier === 'TJK'
																	? item.sI[0].fD.aI.code
																	: ''
															}${
																item.Supplier === 'TBO'
																	? item.Segments[0].slice(0, 1).map((i) => {
																			return i.Airline.FlightNumber;
																	  })
																	: item.Supplier === 'ETR'
																	? item.Segments[0].Flight_Number
																	: item.Supplier === 'TJK'
																	? item.sI[0].fD.fN
																	: ''
															}`}
														</span>
													</Box>

													<Box>
														<span
															style={{
																fontSize: 14,
																color: 'rgba(0,0,0,.38)',
															}}>
															{item.Supplier === 'TBO'
																? item.FareRules[0].Origin
																: item.Supplier === 'ETR'
																? item.Origin
																: item.Supplier === 'TJK'
																? item.sI[0].da.code
																: ''}
														</span>
														<br></br>
														<span style={{ fontSize: 26 }}>
															{item.Supplier === 'TBO'
																? item.Segments[0].slice(0, 1).map((i) => {
																		return i.Origin.DepTime.substr(11, 5);
																  })
																: item.Supplier === 'ETR'
																? item.Segments[0].Departure_DateTime.split(
																		' '
																  )[1]
																: item.Supplier === 'TJK'
																? item.sI[0].dt.substr(11, 5)
																: ''}
														</span>
														<br></br>
														<span
															style={{
																fontSize: 12,
																color: 'rgba(0,0,0,.38)',
															}}>
															{/* Tue, 15 Aug */}
															{`${new Date(
																item.Supplier === 'TBO'
																	? item.Segments[0].slice(0, 1).map((i) => {
																			return i.Origin.DepTime.split('T')[0];
																	  })
																	: item.Supplier === 'ETR'
																	? item.Segments[0].Departure_DateTime.split(
																			' '
																	  )[0]
																	: item.Supplier === 'TJK'
																	? item.sI[0].dt.split('T')[0]
																	: ''
															).toLocaleString('en-us', {
																weekday: 'short',
															})} ,  ${new Date(
																item.Supplier === 'TBO'
																	? item.Segments[0].slice(0, 1).map((i) => {
																			return i.Origin.DepTime.split('T')[0];
																	  })
																	: item.Supplier === 'ETR'
																	? item.Segments[0].Departure_DateTime.split(
																			' '
																	  )[0]
																	: item.Supplier === 'TJK'
																	? item.sI[0].dt.split('T')[0]
																	: ''
															).getDate()} ${new Date(
																item.Supplier === 'TBO'
																	? item.Segments[0].slice(0, 1).map((i) => {
																			return i.Origin.DepTime.split('T')[0];
																	  })
																	: item.Supplier === 'ETR'
																	? item.Segments[0].Departure_DateTime.split(
																			' '
																	  )[0]
																	: item.Supplier === 'TJK'
																	? item.sI[0].dt.split('T')[0]
																	: ''
															).toLocaleString('en-us', {
																month: 'short',
															})}`}
														</span>
														<br></br>
														{/* <span
														style={{ fontSize: 12, color: 'rgba(0,0,0,.38)' }}>
														Mumbai
													</span> */}
													</Box>
													<Box textAlign={'center'}>
														<span
															style={{
																fontSize: 14,
																color: 'rgba(0,0,0,.38)',
															}}>
															2hr 15min
														</span>
														<br></br>
														<span>-------------------</span>
														<br></br>

														<span>
															{item.Supplier === 'TBO'
																? item.Segments[0].length === 1
																	? 'Non Stop'
																	: item.Segments[0].length === 2
																	? '1 Stop'
																	: item.Segments[0].length === 3
																	? '2 Stop'
																	: ''
																: item.Supplier === 'ETR'
																? item.Segments.length === 1
																	? 'Non Stop'
																	: item.Segments.length === 2
																	? '1 Stop'
																	: item.Segments.length === 3
																	? '2 Stop'
																	: ''
																: item.Supplier === 'TJK'
																? item.sI.length === 1
																	? 'Non Stop'
																	: item.sI.length === 2
																	? '1 Stop'
																	: item.sI.length === 3
																	? '2 Stop'
																	: ''
																: ''}
														</span>
													</Box>
													<Box>
														<span
															style={{
																fontSize: 14,
																color: 'rgba(0,0,0,.38)',
															}}>
															{item.Supplier === 'TBO'
																? item.Segments[0].length == 2
																	? item.Segments[0]
																			.filter((i, index) => index === 1)
																			.map((it) => {
																				return it.Destination.Airport
																					.AirportCode;
																			})
																	: item.Segments[0].length == 3
																	? item.Segments[0]
																			.filter((i, index) => index === 2)
																			.map((it) => {
																				return it.Destination.Airport
																					.AirportCode;
																			})
																	: item.Segments[0].length == 1
																	? item.Segments[0].map((it) => {
																			return it.Destination.Airport.AirportCode;
																	  })
																	: ''
																: item.Supplier === 'ETR'
																? item.Destination
																: item.Supplier === 'TJK'
																? item.sI.length === 1
																	? item.sI
																			.filter((i, index) => index === 0)
																			.map((it) => {
																				return it.aa.cityCode;
																			})
																	: item.sI.length === 2
																	? item.sI
																			.filter((i, index) => index === 1)
																			.map((it) => {
																				return it.aa.cityCode;
																			})
																	: item.sI.length === 3
																	? item.sI
																			.filter((i, index) => index === 2)
																			.map((it) => {
																				return it.aa.cityCode;
																			})
																	: ''
																: ''}
														</span>
														<br></br>
														<span style={{ fontSize: 26 }}>
															{item.AirlineCode
																? item.Segments[0].length == 3
																	? item.Segments[0]
																			.filter((i, index) => index === 2)
																			.map((i) => {
																				return i.Destination.ArrTime.substr(
																					11,
																					5
																				);
																			})
																	: item.Segments[0].length == 2
																	? item.Segments[0]
																			.filter((i, index) => index === 1)
																			.map((i) => {
																				return i.Destination.ArrTime.substr(
																					11,
																					5
																				);
																			})
																	: item.Segments[0].length == 1
																	? item.Segments[0]
																			.filter((i, index) => index === 0)
																			.map((i) => {
																				return i.Destination.ArrTime.substr(
																					11,
																					5
																				);
																			})
																	: ''
																: item.Supplier === 'ETR'
																? item.Segments.length === 1
																	? item.Segments.filter(
																			(i, index) => index === 0
																	  ).map((it) => {
																			return it.Arrival_DateTime.substr(11, 5);
																	  })
																	: item.Segments.length === 2
																	? item.Segments.filter(
																			(i, index) => index === 1
																	  ).map((it) => {
																			return it.Arrival_DateTime.substr(11, 5);
																	  })
																	: item.Segments.length === 3
																	? item.Segments.filter(
																			(i, index) => index === 2
																	  ).map((it) => {
																			return it.Arrival_DateTime.substr(11, 5);
																	  })
																	: ''
																: item.Supplier === 'TJK'
																? item.sI.length === 1
																	? item.sI
																			.filter((i, index) => index === 0)
																			.map((it) => {
																				return it.at.substr(11, 5);
																			})
																	: item.sI.length === 2
																	? item.sI
																			.filter((i, index) => index === 1)
																			.map((it) => {
																				return it.at.substr(11, 5);
																			})
																	: item.sI.length === 3
																	? item.sI
																			.filter((i, index) => index === 2)
																			.map((it) => {
																				return it.at.substr(11, 5);
																			})
																	: ''
																: ''}{' '}
														</span>
														<br></br>
														<span
															style={{
																fontSize: 12,
																color: 'rgba(0,0,0,.38)',
															}}>
															{`${new Date(
																item.AirlineCode
																	? item.Segments[0].length == 3
																		? item.Segments[0]
																				.filter((i, index) => index === 2)
																				.map((i) => {
																					return i.Destination.ArrTime.split(
																						'T'
																					)[0];
																				})
																		: item.Segments[0].length == 2
																		? item.Segments[0]
																				.filter((i, index) => index === 1)
																				.map((i) => {
																					return i.Destination.ArrTime.split(
																						'T'
																					)[0];
																				})
																		: item.Segments[0].length == 1
																		? item.Segments[0]
																				.filter((i, index) => index === 0)
																				.map((i) => {
																					return i.Destination.ArrTime.split(
																						'T'
																					)[0];
																				})
																		: ''
																	: item.Supplier === 'ETR'
																	? item.Segments.length === 1
																		? item.Segments.filter(
																				(i, index) => index === 0
																		  ).map((it) => {
																				return it.Arrival_DateTime.split(
																					' '
																				)[0];
																		  })
																		: item.Segments.length === 2
																		? item.Segments.filter(
																				(i, index) => index === 1
																		  ).map((it) => {
																				return it.Arrival_DateTime.split(
																					' '
																				)[0];
																		  })
																		: item.Segments.length === 3
																		? item.Segments.filter(
																				(i, index) => index === 2
																		  ).map((it) => {
																				return it.Arrival_DateTime.split(
																					' '
																				)[0];
																		  })
																		: ''
																	: item.Supplier === 'TJK'
																	? item.sI.length === 1
																		? item.sI
																				.filter((i, index) => index === 0)
																				.map((it) => {
																					return it.at.split('T')[0];
																				})
																		: item.sI.length === 2
																		? item.sI
																				.filter((i, index) => index === 1)
																				.map((it) => {
																					return it.at.split('T')[0];
																				})
																		: item.sI.length === 3
																		? item.sI
																				.filter((i, index) => index === 2)
																				.map((it) => {
																					return it.at.split('T')[0];
																				})
																		: ''
																	: ''
															).toLocaleString('en-us', {
																weekday: 'short',
															})} ,  ${new Date(
																item.AirlineCode
																	? item.Segments[0].length == 3
																		? item.Segments[0]
																				.filter((i, index) => index === 2)
																				.map((i) => {
																					return i.Destination.ArrTime.split(
																						'T'
																					)[0];
																				})
																		: item.Segments[0].length == 2
																		? item.Segments[0]
																				.filter((i, index) => index === 1)
																				.map((i) => {
																					return i.Destination.ArrTime.split(
																						'T'
																					)[0];
																				})
																		: item.Segments[0].length == 1
																		? item.Segments[0]
																				.filter((i, index) => index === 0)
																				.map((i) => {
																					return i.Destination.ArrTime.split(
																						'T'
																					)[0];
																				})
																		: ''
																	: item.Supplier === 'ETR'
																	? item.Segments.length === 1
																		? item.Segments.filter(
																				(i, index) => index === 0
																		  ).map((it) => {
																				return it.Arrival_DateTime.split(
																					' '
																				)[0];
																		  })
																		: item.Segments.length === 2
																		? item.Segments.filter(
																				(i, index) => index === 1
																		  ).map((it) => {
																				return it.Arrival_DateTime.split(
																					' '
																				)[0];
																		  })
																		: item.Segments.length === 3
																		? item.Segments.filter(
																				(i, index) => index === 2
																		  ).map((it) => {
																				return it.Arrival_DateTime.split(
																					' '
																				)[0];
																		  })
																		: ''
																	: item.Supplier === 'TJK'
																	? item.sI.length === 1
																		? item.sI
																				.filter((i, index) => index === 0)
																				.map((it) => {
																					return it.at.split('T')[0];
																				})
																		: item.sI.length === 2
																		? item.sI
																				.filter((i, index) => index === 1)
																				.map((it) => {
																					return it.at.split('T')[0];
																				})
																		: item.sI.length === 3
																		? item.sI
																				.filter((i, index) => index === 2)
																				.map((it) => {
																					return it.at.split('T')[0];
																				})
																		: ''
																	: ''
															).getDate()} ${new Date(
																item.AirlineCode
																	? item.Segments[0].length == 3
																		? item.Segments[0]
																				.filter((i, index) => index === 2)
																				.map((i) => {
																					return i.Destination.ArrTime.split(
																						'T'
																					)[0];
																				})
																		: item.Segments[0].length == 2
																		? item.Segments[0]
																				.filter((i, index) => index === 1)
																				.map((i) => {
																					return i.Destination.ArrTime.split(
																						'T'
																					)[0];
																				})
																		: item.Segments[0].length == 1
																		? item.Segments[0]
																				.filter((i, index) => index === 0)
																				.map((i) => {
																					return i.Destination.ArrTime.split(
																						'T'
																					)[0];
																				})
																		: ''
																	: item.Supplier === 'ETR'
																	? item.Segments.length === 1
																		? item.Segments.filter(
																				(i, index) => index === 0
																		  ).map((it) => {
																				return it.Arrival_DateTime.split(
																					' '
																				)[0];
																		  })
																		: item.Segments.length === 2
																		? item.Segments.filter(
																				(i, index) => index === 1
																		  ).map((it) => {
																				return it.Arrival_DateTime.split(
																					' '
																				)[0];
																		  })
																		: item.Segments.length === 3
																		? item.Segments.filter(
																				(i, index) => index === 2
																		  ).map((it) => {
																				return it.Arrival_DateTime.split(
																					' '
																				)[0];
																		  })
																		: ''
																	: item.Supplier === 'TJK'
																	? item.sI.length === 1
																		? item.sI
																				.filter((i, index) => index === 0)
																				.map((it) => {
																					return it.at.split('T')[0];
																				})
																		: item.sI.length === 2
																		? item.sI
																				.filter((i, index) => index === 1)
																				.map((it) => {
																					return it.at.split('T')[0];
																				})
																		: item.sI.length === 3
																		? item.sI
																				.filter((i, index) => index === 2)
																				.map((it) => {
																					return it.at.split('T')[0];
																				})
																		: ''
																	: ''
															).toLocaleString('en-us', {
																month: 'short',
															})}`}
														</span>
														<br></br>
														{/* <span
														style={{ fontSize: 12, color: 'rgba(0,0,0,.38)' }}>
														Mumbai
													</span> */}
													</Box>
													<h2>
														₹
														{item.Supplier === 'TBO'
															? Number(
																	Math.round(
																		Number(
																			Number(
																				Math.round(item.Fare.Total_Amount)
																			) -
																				Number(
																					Math.round(item.Fare.MFB_Discount)
																				)
																		)
																	)
															  )
															: item.Supplier === 'ETR'
															? Number(
																	Math.round(
																		Number(
																			Number(
																				Math.round(item.Fares.Total_Amount)
																			)
																		)
																	)
															  )
															: item.Supplier === 'TJK'
															? Number(
																	Math.round(
																		Number(
																			Number(
																				Math.round(
																					item.totalPriceList.fd.Total_Amount
																				)
																			)
																		)
																	)
															  )
															: ''}
													</h2>
													<Button
														onClick={() =>
															navigate('/flightbooking', {
																state: {
																	onward: item,
																	formData: location.state,
																},
															})
														}
														style={{
															background: '#EC5B24',
															color: 'white',
															width: '18%',
														}}>
														Book
													</Button>
												</Box>
											</>
										) : (
											''
										);
									})}
								</InfiniteScroll>
							) : filterData?.length > 0 ? (
								<InfiniteScroll
									dataLength={scrollVal}
									next={fetchMoreData}
									hasMore={hasMorefilterData}
									loader={<h4 style={{ textAlign: 'center' }}>Loading...</h4>}
									endMessage={
										<p style={{ textAlign: 'center' }}>
											<b>No More Flights</b>
										</p>
									}>
									{filterData?.map((item, index) => {
										return index < scrollVal ? (
											<>
												<Box
													style={{
														display: 'flex',
														justifyContent: 'space-between',
														alignItems: 'center',
														borderRadius: 4,
														background: '#fff',
														filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, .25))',
														padding: 30,
														marginTop: 10,
													}}>
													<Box>
														<img
															src={`https://nitish.musafirbazar.com/static/media/${
																item.Supplier === 'TBO'
																	? item.AirlineCode
																	: item.Supplier === 'ETR'
																	? item.Airline_Code
																	: item.Supplier === 'TJK'
																	? item.sI[0].fD.aI.code
																	: ''
															}.gif`}
															style={{ height: 50 }}
														/>
														<br></br>
														<span
															style={{
																color: 'rgba(0,0,0,.38)',
																fontSize: 12,
															}}>
															{item.Supplier === 'TBO'
																? item.Segments[0].slice(0, 1).map((i) => {
																		return i.Airline.AirlineName;
																  })
																: item.Supplier === 'ETR'
																? item.Segments[0].Airline_Name
																: item.Supplier === 'TJK'
																? item.sI[0].fD.aI.name
																: ''}
														</span>
														<br></br>
														<span
															style={{
																color: 'rgba(0,0,0,.38)',
																fontSize: 12,
															}}>
															{`${
																item.Supplier === 'TBO'
																	? item.AirlineCode
																	: item.Supplier === 'ETR'
																	? item.Segments[0].Airline_Code
																	: item.Supplier === 'TJK'
																	? item.sI[0].fD.aI.code
																	: ''
															}${
																item.Supplier === 'TBO'
																	? item.Segments[0].slice(0, 1).map((i) => {
																			return i.Airline.FlightNumber;
																	  })
																	: item.Supplier === 'ETR'
																	? item.Segments[0].Flight_Number
																	: item.Supplier === 'TJK'
																	? item.sI[0].fD.fN
																	: ''
															}`}
														</span>
													</Box>

													<Box>
														<span
															style={{
																fontSize: 14,
																color: 'rgba(0,0,0,.38)',
															}}>
															{item.Supplier === 'TBO'
																? item.FareRules[0].Origin
																: item.Supplier === 'ETR'
																? item.Origin
																: item.Supplier === 'TJK'
																? item.sI[0].da.code
																: ''}
														</span>
														<br></br>
														<span style={{ fontSize: 26 }}>
															{item.Supplier === 'TBO'
																? item.Segments[0].slice(0, 1).map((i) => {
																		return i.Origin.DepTime.substr(11, 5);
																  })
																: item.Supplier === 'ETR'
																? item.Segments[0].Departure_DateTime.split(
																		' '
																  )[1]
																: item.Supplier === 'TJK'
																? item.sI[0].dt.substr(11, 5)
																: ''}
														</span>
														<br></br>
														<span
															style={{
																fontSize: 12,
																color: 'rgba(0,0,0,.38)',
															}}>
															{/* Tue, 15 Aug */}
															{`${new Date(
																item.Supplier === 'TBO'
																	? item.Segments[0].slice(0, 1).map((i) => {
																			return i.Origin.DepTime.split('T')[0];
																	  })
																	: item.Supplier === 'ETR'
																	? item.Segments[0].Departure_DateTime.split(
																			' '
																	  )[0]
																	: item.Supplier === 'TJK'
																	? item.sI[0].dt.split('T')[0]
																	: ''
															).toLocaleString('en-us', {
																weekday: 'short',
															})} ,  ${new Date(
																item.Supplier === 'TBO'
																	? item.Segments[0].slice(0, 1).map((i) => {
																			return i.Origin.DepTime.split('T')[0];
																	  })
																	: item.Supplier === 'ETR'
																	? item.Segments[0].Departure_DateTime.split(
																			' '
																	  )[0]
																	: item.Supplier === 'TJK'
																	? item.sI[0].dt.split('T')[0]
																	: ''
															).getDate()} ${new Date(
																item.Supplier === 'TBO'
																	? item.Segments[0].slice(0, 1).map((i) => {
																			return i.Origin.DepTime.split('T')[0];
																	  })
																	: item.Supplier === 'ETR'
																	? item.Segments[0].Departure_DateTime.split(
																			' '
																	  )[0]
																	: item.Supplier === 'TJK'
																	? item.sI[0].dt.split('T')[0]
																	: ''
															).toLocaleString('en-us', {
																month: 'short',
															})}`}
														</span>
														<br></br>
														{/* <span
														style={{ fontSize: 12, color: 'rgba(0,0,0,.38)' }}>
														Mumbai
													</span> */}
													</Box>
													<Box textAlign={'center'}>
														<span
															style={{
																fontSize: 14,
																color: 'rgba(0,0,0,.38)',
															}}>
															2hr 15min
														</span>
														<br></br>
														<span>-------------------</span>
														<br></br>

														<span>
															{item.Supplier === 'TBO'
																? item.Segments[0].length === 1
																	? 'Non Stop'
																	: item.Segments[0].length === 2
																	? '1 Stop'
																	: item.Segments[0].length === 3
																	? '2 Stop'
																	: ''
																: item.Supplier === 'ETR'
																? item.Segments.length === 1
																	? 'Non Stop'
																	: item.Segments.length === 2
																	? '1 Stop'
																	: item.Segments.length === 3
																	? '2 Stop'
																	: ''
																: item.Supplier === 'TJK'
																? item.sI.length === 1
																	? 'Non Stop'
																	: item.sI.length === 2
																	? '1 Stop'
																	: item.sI.length === 3
																	? '2 Stop'
																	: ''
																: ''}
														</span>
													</Box>
													<Box>
														<span
															style={{
																fontSize: 14,
																color: 'rgba(0,0,0,.38)',
															}}>
															{item.Supplier === 'TBO'
																? item.Segments[0].length == 2
																	? item.Segments[0]
																			.filter((i, index) => index === 1)
																			.map((it) => {
																				return it.Destination.Airport
																					.AirportCode;
																			})
																	: item.Segments[0].length == 3
																	? item.Segments[0]
																			.filter((i, index) => index === 2)
																			.map((it) => {
																				return it.Destination.Airport
																					.AirportCode;
																			})
																	: item.Segments[0].length == 1
																	? item.Segments[0].map((it) => {
																			return it.Destination.Airport.AirportCode;
																	  })
																	: ''
																: item.Supplier === 'ETR'
																? item.Destination
																: item.Supplier === 'TJK'
																? item.sI.length === 1
																	? item.sI
																			.filter((i, index) => index === 0)
																			.map((it) => {
																				return it.aa.cityCode;
																			})
																	: item.sI.length === 2
																	? item.sI
																			.filter((i, index) => index === 1)
																			.map((it) => {
																				return it.aa.cityCode;
																			})
																	: item.sI.length === 3
																	? item.sI
																			.filter((i, index) => index === 2)
																			.map((it) => {
																				return it.aa.cityCode;
																			})
																	: ''
																: ''}
														</span>
														<br></br>
														<span style={{ fontSize: 26 }}>
															{item.AirlineCode
																? item.Segments[0].length == 3
																	? item.Segments[0]
																			.filter((i, index) => index === 2)
																			.map((i) => {
																				return i.Destination.ArrTime.substr(
																					11,
																					5
																				);
																			})
																	: item.Segments[0].length == 2
																	? item.Segments[0]
																			.filter((i, index) => index === 1)
																			.map((i) => {
																				return i.Destination.ArrTime.substr(
																					11,
																					5
																				);
																			})
																	: item.Segments[0].length == 1
																	? item.Segments[0]
																			.filter((i, index) => index === 0)
																			.map((i) => {
																				return i.Destination.ArrTime.substr(
																					11,
																					5
																				);
																			})
																	: ''
																: item.Supplier === 'ETR'
																? item.Segments.length === 1
																	? item.Segments.filter(
																			(i, index) => index === 0
																	  ).map((it) => {
																			return it.Arrival_DateTime.substr(11, 5);
																	  })
																	: item.Segments.length === 2
																	? item.Segments.filter(
																			(i, index) => index === 1
																	  ).map((it) => {
																			return it.Arrival_DateTime.substr(11, 5);
																	  })
																	: item.Segments.length === 3
																	? item.Segments.filter(
																			(i, index) => index === 2
																	  ).map((it) => {
																			return it.Arrival_DateTime.substr(11, 5);
																	  })
																	: ''
																: item.Supplier === 'TJK'
																? item.sI.length === 1
																	? item.sI
																			.filter((i, index) => index === 0)
																			.map((it) => {
																				return it.at.substr(11, 5);
																			})
																	: item.sI.length === 2
																	? item.sI
																			.filter((i, index) => index === 1)
																			.map((it) => {
																				return it.at.substr(11, 5);
																			})
																	: item.sI.length === 3
																	? item.sI
																			.filter((i, index) => index === 2)
																			.map((it) => {
																				return it.at.substr(11, 5);
																			})
																	: ''
																: ''}{' '}
														</span>
														<br></br>
														<span
															style={{
																fontSize: 12,
																color: 'rgba(0,0,0,.38)',
															}}>
															{`${new Date(
																item.AirlineCode
																	? item.Segments[0].length == 3
																		? item.Segments[0]
																				.filter((i, index) => index === 2)
																				.map((i) => {
																					return i.Destination.ArrTime.split(
																						'T'
																					)[0];
																				})
																		: item.Segments[0].length == 2
																		? item.Segments[0]
																				.filter((i, index) => index === 1)
																				.map((i) => {
																					return i.Destination.ArrTime.split(
																						'T'
																					)[0];
																				})
																		: item.Segments[0].length == 1
																		? item.Segments[0]
																				.filter((i, index) => index === 0)
																				.map((i) => {
																					return i.Destination.ArrTime.split(
																						'T'
																					)[0];
																				})
																		: ''
																	: item.Supplier === 'ETR'
																	? item.Segments.length === 1
																		? item.Segments.filter(
																				(i, index) => index === 0
																		  ).map((it) => {
																				return it.Arrival_DateTime.split(
																					' '
																				)[0];
																		  })
																		: item.Segments.length === 2
																		? item.Segments.filter(
																				(i, index) => index === 1
																		  ).map((it) => {
																				return it.Arrival_DateTime.split(
																					' '
																				)[0];
																		  })
																		: item.Segments.length === 3
																		? item.Segments.filter(
																				(i, index) => index === 2
																		  ).map((it) => {
																				return it.Arrival_DateTime.split(
																					' '
																				)[0];
																		  })
																		: ''
																	: item.Supplier === 'TJK'
																	? item.sI.length === 1
																		? item.sI
																				.filter((i, index) => index === 0)
																				.map((it) => {
																					return it.at.split('T')[0];
																				})
																		: item.sI.length === 2
																		? item.sI
																				.filter((i, index) => index === 1)
																				.map((it) => {
																					return it.at.split('T')[0];
																				})
																		: item.sI.length === 3
																		? item.sI
																				.filter((i, index) => index === 2)
																				.map((it) => {
																					return it.at.split('T')[0];
																				})
																		: ''
																	: ''
															).toLocaleString('en-us', {
																weekday: 'short',
															})} ,  ${new Date(
																item.AirlineCode
																	? item.Segments[0].length == 3
																		? item.Segments[0]
																				.filter((i, index) => index === 2)
																				.map((i) => {
																					return i.Destination.ArrTime.split(
																						'T'
																					)[0];
																				})
																		: item.Segments[0].length == 2
																		? item.Segments[0]
																				.filter((i, index) => index === 1)
																				.map((i) => {
																					return i.Destination.ArrTime.split(
																						'T'
																					)[0];
																				})
																		: item.Segments[0].length == 1
																		? item.Segments[0]
																				.filter((i, index) => index === 0)
																				.map((i) => {
																					return i.Destination.ArrTime.split(
																						'T'
																					)[0];
																				})
																		: ''
																	: item.Supplier === 'ETR'
																	? item.Segments.length === 1
																		? item.Segments.filter(
																				(i, index) => index === 0
																		  ).map((it) => {
																				return it.Arrival_DateTime.split(
																					' '
																				)[0];
																		  })
																		: item.Segments.length === 2
																		? item.Segments.filter(
																				(i, index) => index === 1
																		  ).map((it) => {
																				return it.Arrival_DateTime.split(
																					' '
																				)[0];
																		  })
																		: item.Segments.length === 3
																		? item.Segments.filter(
																				(i, index) => index === 2
																		  ).map((it) => {
																				return it.Arrival_DateTime.split(
																					' '
																				)[0];
																		  })
																		: ''
																	: item.Supplier === 'TJK'
																	? item.sI.length === 1
																		? item.sI
																				.filter((i, index) => index === 0)
																				.map((it) => {
																					return it.at.split('T')[0];
																				})
																		: item.sI.length === 2
																		? item.sI
																				.filter((i, index) => index === 1)
																				.map((it) => {
																					return it.at.split('T')[0];
																				})
																		: item.sI.length === 3
																		? item.sI
																				.filter((i, index) => index === 2)
																				.map((it) => {
																					return it.at.split('T')[0];
																				})
																		: ''
																	: ''
															).getDate()} ${new Date(
																item.AirlineCode
																	? item.Segments[0].length == 3
																		? item.Segments[0]
																				.filter((i, index) => index === 2)
																				.map((i) => {
																					return i.Destination.ArrTime.split(
																						'T'
																					)[0];
																				})
																		: item.Segments[0].length == 2
																		? item.Segments[0]
																				.filter((i, index) => index === 1)
																				.map((i) => {
																					return i.Destination.ArrTime.split(
																						'T'
																					)[0];
																				})
																		: item.Segments[0].length == 1
																		? item.Segments[0]
																				.filter((i, index) => index === 0)
																				.map((i) => {
																					return i.Destination.ArrTime.split(
																						'T'
																					)[0];
																				})
																		: ''
																	: item.Supplier === 'ETR'
																	? item.Segments.length === 1
																		? item.Segments.filter(
																				(i, index) => index === 0
																		  ).map((it) => {
																				return it.Arrival_DateTime.split(
																					' '
																				)[0];
																		  })
																		: item.Segments.length === 2
																		? item.Segments.filter(
																				(i, index) => index === 1
																		  ).map((it) => {
																				return it.Arrival_DateTime.split(
																					' '
																				)[0];
																		  })
																		: item.Segments.length === 3
																		? item.Segments.filter(
																				(i, index) => index === 2
																		  ).map((it) => {
																				return it.Arrival_DateTime.split(
																					' '
																				)[0];
																		  })
																		: ''
																	: item.Supplier === 'TJK'
																	? item.sI.length === 1
																		? item.sI
																				.filter((i, index) => index === 0)
																				.map((it) => {
																					return it.at.split('T')[0];
																				})
																		: item.sI.length === 2
																		? item.sI
																				.filter((i, index) => index === 1)
																				.map((it) => {
																					return it.at.split('T')[0];
																				})
																		: item.sI.length === 3
																		? item.sI
																				.filter((i, index) => index === 2)
																				.map((it) => {
																					return it.at.split('T')[0];
																				})
																		: ''
																	: ''
															).toLocaleString('en-us', {
																month: 'short',
															})}`}
														</span>
														<br></br>
														{/* <span
														style={{ fontSize: 12, color: 'rgba(0,0,0,.38)' }}>
														Mumbai
													</span> */}
													</Box>
													<h2>
														₹
														{item.Supplier === 'TBO'
															? Number(
																	Math.round(
																		Number(
																			Number(
																				Math.round(item.Fare.Total_Amount)
																			) -
																				Number(
																					Math.round(item.Fare.MFB_Discount)
																				)
																		)
																	)
															  )
															: item.Supplier === 'ETR'
															? Number(
																	Math.round(
																		Number(
																			Number(
																				Math.round(item.Fares.Total_Amount)
																			)
																		)
																	)
															  )
															: item.Supplier === 'TJK'
															? Number(
																	Math.round(
																		Number(
																			Number(
																				Math.round(
																					item.totalPriceList.fd.Total_Amount
																				)
																			)
																		)
																	)
															  )
															: ''}
													</h2>
													<Button
														onClick={() =>
															navigate('/flightbooking', {
																state: {
																	onward: item,
																	formData: location.state,
																},
															})
														}
														style={{
															background: '#EC5B24',
															color: 'white',
															width: '18%',
														}}>
														Book
													</Button>
												</Box>
												{/* <Box
												style={{
													alignItems: 'center',
													borderRadius: 4,
													background: '#fff',
													// filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, .25))',
												}}>
												<span>Flight Details</span>
											</Box> */}
											</>
										) : (
											''
										);
									})}
								</InfiniteScroll>
							) : (
								Array.from(Array(10)).map((i) => {
									return <FlightResultSkeleton />;
								})
							)
						) : (
							Array.from(Array(10)).map((i) => {
								return <FlightResultSkeleton />;
							})
						)}
					</Grid>
					<Grid item xs={12} lg={4}>
						<Box>
							<img src='https://tpc.googlesyndication.com/simgad/16156858053234787891?sqp=4sqPyQQrQikqJwhfEAEdAAC0QiABKAEwCTgDQPCTCUgAUAFYAWBfcAJ4AcUBLbKdPg&rs=AOga4qmd7sh5rWiWjxdzaN9vw44WnXQdZA' />
						</Box>
					</Grid>
				</Grid>
			</Box>
			<TopDrawer
				draw={draw}
				setDraw={setDraw}
				filterAirlineTBO={filterAirlineTBO}
				airlineS={airlineS}
				handleAirline={handleAirline}
				fareType={fareType}
				handleFareType={handleFareType}
				fare={fare}
				stopType={stopType}
				handleStopType={handleStopType}
				stop={stop}
			/>
			<Footer />
		</div>
	);
};

export default SearchResultPage;
